function MytaIdea() {
  return (
    <div className="w-full h-full">
      <div className="flex flex-col w-full pt-10 px-4 bg-gradient-to-b from-[#010d0d] to-[#132f32] pb-6">
        <p className="font-bold text-lg text-white mb-3">Рады видеть тебя в MYTA!</p>
        <p className="text-white">
          Наше приложение помогает не просто найти пару, но и провести идеальный вечер в реальном мире.
        </p>

        <img className="w-full max-h-[262px] mb-6" src="/images/myta-idia.png" alt="myta" />
        <p className="font-bold text-lg text-white">Благодарим за выбор MYTA ❤️</p>
      </div>
    </div>
  );
}

export default MytaIdea;
